module.exports = __webpack_public_path__ + "static/media/blog6_pic1.c597cb04.png";